import './Empty.css';

export default function Empty({ symbol, title, body, cta, dark }) {
  return (
    <div className={`empty${dark ? ' empty--dark' : ''}`}>
      {symbol && <div className="empty__symbol">{symbol}</div>}
      {title && <h4 className="empty__title">{title}</h4>}
      {body && <p className="empty__body">{body}</p>}
      {cta}
    </div>
  );
}
